<template>
	<nav>
		<ul>
			<li class="mi-start">
				<router-link :to="{ name: 'Start'}">Start</router-link>
			</li>
			<li class="mi-institutions">
				<router-link :to="{ name: 'Customers'}">Institutioner</router-link>
			</li>
			<li class="mi-agreements">
				<router-link :to="{ name: 'AgreementsAll', params: { customerid: 0 } }">Aftaler</router-link>
			</li>
			<li class="mi-orders">
				<router-link :to="{ name: 'Orders'}">Bestillinger</router-link>
			</li>
			<li class="mi-products">
				<router-link :to="{ name: 'Products'}">Produkter</router-link>
			</li>
			<li class="mi-menuexpand">
				<a></a>
			</li>
		</ul>
		<span></span>
	</nav>
</template>

<script>
	export default {
		name: "Nav"
	};
</script>